import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { Redirect } from 'react-router'
import { Elements, TextInput, TextButton } from '@tfo/common'
import * as Common from '@tfo/common'
import { useStore } from '../../hooks/useStore'
import { LoginType } from '@tfo/ppl'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import './Password.scss'
import { IconButton, InputAdornment, OutlinedInput } from '@material-ui/core'

const { InputErrorMessage } = Elements

const Password = observer(({onReset: onReset, hideCancelButton}: {
    onReset: (logintType: LoginType) => void
    hideCancelButton: boolean}) => {
    const intl = useIntl()
    const { loginStore: store } = useStore()
    const [showPassword, setShowPassword] = React.useState(false)


    return Common.utils.loggedIn() ? (
        <Redirect to="/start" />
    ) : (
        <div className={'Password'}>
             <OutlinedInput
                className='not-first-field'
                value={store.email}
                onChange={e => store.onChange('email', e.target.value)}
                error={store.hasError}
                type="email"
                placeholder={intl.formatMessage({ id: 'common.email.address' })}
            />
            <OutlinedInput
                className='not-first-field'
                value={store.password}
                onChange={e => store.onChange('password', e.target.value)}
                onKeyDown={e => store.onKeyDown(e.keyCode)}
                error={store.hasError}
                type={showPassword ? 'text' : 'password'}
                placeholder={intl.formatMessage({ id: 'loginpage.password' })}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={e => e.preventDefault()}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />

            {
                store.hasError && (
                    <InputErrorMessage>
                        {intl.formatMessage({ id: 'loginpage.errormessage.login' })}
                    </InputErrorMessage>
                )
            }

            <TextButton data-cy="login" onClick={() => store.onLogin()}>
                {intl.formatMessage({ id: 'loginpage.login' })}
            </TextButton>

            {!hideCancelButton && 
            <TextButton onClick={() => onReset(LoginType.None)} className='abort-button' secondary>
               {intl.formatMessage({ id: 'bankid.cancelButton' })}
            </TextButton>
            }
        </div>
    )
})

export default Password